import { SortResult } from '@/components';
import { Http, Paged, Paging } from '@/core';
import { guard } from '@/utils';
import qs from 'qs';
import {
  AddArticleDto,
  ArticleDto,
  ArticleLookupDto,
  ArticleStatus,
  UpdateArticleDto,
} from './articleTypes';

class ArticlesHttp extends Http {
  public async getAll() {
    const response = await this._axios.get<ArticleDto[]>(`/api/article`);
    return response.data;
  }

  public async getPublished(statuses?: ArticleStatus[]) {
    const query = qs.stringify({ statuses });
    const response = await this._axios.get<ArticleDto[]>(
      `/api/article/published?${query}`,
    );
    return response.data;
  }

  public async search(args: {
    statuses?: ArticleStatus[];
    searchString?: string;
    paging: Paging;
    sorting?: SortResult;
  }) {
    const query = qs.stringify(args);
    const response = await this._axios.get<Paged<ArticleLookupDto>>(
      `/api/article/search?${query}`,
    );
    return response.data;
  }

  public async get(id: string) {
    guard.notNull(id, 'id');
    const response = await this._axios.get<ArticleDto>(`/api/article/${id}`);
    return response.data;
  }

  public async create(request: AddArticleDto) {
    guard.notNull(request, 'request');
    const response = await this._axios.post<string>('/api/article', request);
    return response.data;
  }

  public async update(request: UpdateArticleDto) {
    guard.notNull(request, 'request');
    await this._axios.put('/api/article', request);
  }

  public async remove(id: string) {
    guard.notNull(id, 'id');
    await this._axios.delete(`/api/article/${id}`);
  }

  public async publish(id: string) {
    guard.notNull(id, 'id');
    await this._axios.put(`/api/article/${id}/publish`);
  }

  public async hide(id: string) {
    guard.notNull(id, 'id');
    await this._axios.put(`/api/article/${id}/hide`);
  }
}

export const articlesHttp = new ArticlesHttp();
